import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-90">
      <div className="max-w-3xl mx-auto" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="space-y-8" data-id="element-92">
          <p className="text-2xl md:text-3xl font-serif text-forest leading-relaxed italic border-l-4 border-orange pl-6" data-id="element-93">
            "Sabes exactamente de qué hablo. Te despiertas sintiéndote ligera,
            pero al mediodía tus pantalones empiezan a apretar. Para las 6:00
            PM, sientes que tu abdomen está a punto de estallar y solo quieres
            llegar a casa para ponerte ropa ancha."
          </p>

          <p className="text-lg md:text-xl text-charcoal leading-relaxed" data-id="element-94">
            No has engordado dos kilos de grasa desde la mañana. Tu cuerpo está
            atrapado en un ciclo de inflamación, gases y retención de líquidos
            que te hace sentir pesada, cansada y frustrada frente al espejo.
          </p>
        </motion.div>
      </div>
    </section>;
}